app.directive('signupLong', [function () {
    return {
        templateUrl: 'templates/directives/signupLong.html'
    }
}]);